// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// Promise = chunk loading, 0 = chunk loaded
var installedChunks = {
	"controllers/workbench-article": 0
};

var deferredModules = [
	["./js/NHW/controllers/workbench-article.ts","common"]
];
// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

var checkDeferredModules = function() {};

// install a JSONP callback for chunk loading
var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
	var chunkIds = data[0];
	var moreModules = data[1];
	var runtime = data[2];
	var executeModules = data[3];
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0, resolves = [];
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			resolves.push(installedChunks[chunkId][0]);
		}
		installedChunks[chunkId] = 0;
	}
	for(moduleId in moreModules) {
		if(__webpack_require__.o(moreModules, moduleId)) {
			__webpack_require__.m[moduleId] = moreModules[moduleId];
		}
	}
	if(runtime) runtime(__webpack_require__);
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	while(resolves.length) {
		resolves.shift()();
	}

	// add entry modules from loaded chunk to deferred list
	if(executeModules) deferredModules.push.apply(deferredModules, executeModules);

	// run deferred modules when all chunks ready
	return checkDeferredModules();
}

var chunkLoadingGlobal = self["webpackChunkNationalHardware"] = self["webpackChunkNationalHardware"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));

function checkDeferredModulesImpl() {
	var result;
	for(var i = 0; i < deferredModules.length; i++) {
		var deferredModule = deferredModules[i];
		var fulfilled = true;
		for(var j = 1; j < deferredModule.length; j++) {
			var depId = deferredModule[j];
			if(installedChunks[depId] !== 0) fulfilled = false;
		}
		if(fulfilled) {
			deferredModules.splice(i--, 1);
			result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
		}
	}
	if(deferredModules.length === 0) {
		__webpack_require__.x();
		__webpack_require__.x = function() {};
	}
	return result;
}
var startup = __webpack_require__.x;
__webpack_require__.x = function() {
	// reset startup function so it can be called again when more startup code is added
	__webpack_require__.x = startup || (function() {});
	return (checkDeferredModules = checkDeferredModulesImpl)();
};